export enum AnswerStyleType {
  Default = 'Default',
  Button = 'Button',
  CheckboxWithoutBorder = 'CheckboxWithoutBorder'
}
